// extracted by mini-css-extract-plugin
export default {"wrapper":"StudentWebinarMedia_wrapper__NYTVM","pinned":"StudentWebinarMedia_pinned__sy6u-","peers":"StudentWebinarMedia_peers__qRlAX","list":"StudentWebinarMedia_list__nMVmH"};